@if (deepLink()) {
  <a class="cl-a-external" [href]="link" target="_blank">AWS Console link</a>
}
